import { Button } from '@library/components/buttons';

export interface CloseModalButtonProps {
  btnClassName?: string;
  className?: string;
  handleOnClick: () => void;
  labelClassName?: string;
  useDefaultStyling?: boolean;
}

export const CloseModalButton = ({
  btnClassName = undefined,
  className = '',
  handleOnClick,
  labelClassName = 'text-soClean-100 size-6',
  useDefaultStyling = true
}: CloseModalButtonProps) => {
  const wrapperClasses = useDefaultStyling
    ? 'ml-auto flex h-full items-center justify-center'
    : className;
  const btnClasses =
    btnClassName === '' || !!btnClassName ? btnClassName : 'pr-5';

  return (
    <div className={wrapperClasses}>
      <Button
        className={btnClasses}
        data-testid="close-modal-button"
        title="CloseModalButton"
        onClick={handleOnClick}
      >
        <span className={labelClassName}>✕</span>
      </Button>
    </div>
  );
};
